import React from 'react';
import Navbar from "../components/Navbar";

export default class Contact extends React.Component {
    render() {
        return (
            <div>
                <div className="dark-background" style={{minHeight: '90vh', paddingBottom: '60px'}}>
                    <div className="container">
                        <div className="row justify-content-center page-title-wrapper" style={{marginBottom: '20px'}}>
                            <div className="col-md-3 col-sm-10" style={{textAlign: 'center', maxWidth: '250px', minWidth: '200px'}}>
                                <h1 className="font-satisfy font-peach page-title">Contact</h1>
                                <hr className="flaired-edge-separator"/>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-10 contact-box">
                                <div className="row justify-content-center align-items-center" style={{height: '100%'}}>
                                    <div className="quote-box" style={{color: '#f8e9e8'}}>
                                        <h4 className="font-satisfy" style={{fontSize: '35px'}}>Deanna Dunmyer</h4>
                                        <h6 className="font-josefin adaptable-text">Email: myerspring@gmail.com</h6>
                                        <div style={{height: '50px'}}/>
                                        <h5 className="font-satisfy" style={{fontSize: '35px'}}>Phoenix Artists</h5>
                                        <h6 className="font-josefin adaptable-text">Agent: Gary Epstein</h6>
                                        <h6 className="font-josefin adaptable-text">Address: 330 W 38th St #607, New York, NY 10018</h6>
                                        <h6 className="font-josefin adaptable-text">Phone: (212) 586 9110</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Navbar links={[
                        { text: 'Home', reference: '/home' },
                        { text: 'Resume', reference: '/resume' },
                        { text: 'Gallery', reference: '/gallery' },
                        { text: 'Voice', reference: '/voice' },
                        { text: 'Press', reference: '/press' },
                        { text: 'Contact', reference: '/contact', extraClasses: 'active-link' }
                    ]}/>
                </div>
            </div>
        );
    }
}